import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { SearchQuery, SearchResult } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  searchResults: SearchResult[];
  canSearch: boolean;
  index: number;
  search(request: Boundaries["search"]["request"]): void;
}

function useSearch(query: SearchQuery): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() => selector.isSearchRequestPending(query)),
    isRequestSuccess: useSelector(() => selector.isSearchRequestSuccess(query)),
    isRequestFailure: useSelector(() => selector.isSearchRequestFailure(query)),
    searchResults: useSelector(() => selector.getSearchedResults(query)),
    canSearch: useSelector(() => selector.canSearch(query)),
    index: useSelector(() => selector.getSearchIndex(query)),
    search: core.search,
  };
}

export { useSearch };
